import { createFileRoute } from '@tanstack/react-router';
import { DepartmentCreateForm } from '../../modules/departments/department-create-form.js';

export const Route = createFileRoute('/departments/new')({
  component: NewDepartmentPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewDepartmentPage() {
  return <DepartmentCreateForm />;
}
